/**
 * Modulo com dados do ambiente da aplicação
 */
let data = {
  env: "",
  isDev: false,
  isStaging: false,
  isProduction: false,
  firebaseConfig: {},
  name: "organize-here-app",
  scheduleApi: {
    url: "",
    headers: null,
  }
}

const host = window.location.host

if (host.indexOf("app-staging.organize-here.com") > -1 || host.indexOf("organize-here-staging.firebaseapp.com") > -1) {

  data.env = "staging"
  data.isStaging = true
  data.scheduleApi.url = "https://organize-here-staging.herokuapp.com/api"
  data.scheduleApi.headers = { "x-auth": "AIzaSyB90RPGNLvJR0_06d4922GDl6NG4__RGME" }
  data.firebaseConfig = {
    apiKey: "AIzaSyB90RPGNLvJR0_06d4922GDl6NG4__RGME",
    authDomain: "organize-here-staging.firebaseapp.com",
    databaseURL: "https://organize-here-staging.firebaseio.com",
    projectId: "organize-here-staging",
    storageBucket: "organize-here-staging.appspot.com",
    messagingSenderId: "109843936092",
  }

} else if (host.indexOf("app.organize-here.com") > -1 || host.indexOf("organize-here-production.firebaseapp.com") > -1) {

  data.env = "production"
  data.isProduction = true
  data.scheduleApi.url = "https://schedule.organize-here.com/api"
  data.scheduleApi.headers = { "x-auth": "AIzaSyCJ7OAGyjyBSvo9W7eYYYiLpjDwUDIxbL4" }
  data.firebaseConfig = {
    apiKey: "AIzaSyCJ7OAGyjyBSvo9W7eYYYiLpjDwUDIxbL4",
    authDomain: "organize-here-production.firebaseapp.com",
    databaseURL: "https://organize-here-production.firebaseio.com",
    projectId: "organize-here-production",
    storageBucket: "organize-here-production.appspot.com",
    messagingSenderId: "901850264912",
  }

} else {

  data.env = "dev"
  data.isDev = true
  data.scheduleApi.url = "http://localhost:3000/api"
  data.scheduleApi.headers = { "x-auth": "AIzaSyDAGV_zc5z7vrmVCPfxvUbw1l4QAUaboGg" }
  data.firebaseConfig = {
    apiKey: "AIzaSyDAGV_zc5z7vrmVCPfxvUbw1l4QAUaboGg",
    authDomain: "organize-here-dev.firebaseapp.com",
    databaseURL: "https://organize-here-dev.firebaseio.com",
    projectId: "organize-here-dev",
    storageBucket: "organize-here-dev.appspot.com",
    messagingSenderId: "753376574688",
  }
}

export const AppEnv = data



// WEBPACK FOOTER //
// ./src/app/app.env.ts